(() => {
  const ELEMENT_NAME = 'pickup-availability-drawer';

  if (customElements.get(ELEMENT_NAME)) return;

  const CLASSES = { scrollLocked: 'overflow-hidden' };
  const EVENTS = { closed: 'pickup:closed', opening: 'pickup:opening' };

  const SELECTORS = {
    close: '[data-pickup-availability-close]',
    drawer: ELEMENT_NAME,
    open: '[data-pickup-availability-open], #ShowPickupAvailabilityDrawer',
    overlay: '[data-pickup-availability-overlay]',
  };

  class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();
      this.onBodyClick = this.handleBodyClick.bind(this);

      this.querySelectorAll(SELECTORS.close).forEach((button) => {
        button.addEventListener('click', () => this.hide());
      });

      this.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') this.hide();
      });

      window.PickupAvailabilityO2?.initDrawer(this);
    }

    handleBodyClick(event) {
      const target = event.target;

      if (target != this && !target.closest(SELECTORS.drawer) && !target.closest(SELECTORS.open)) this.hide();
    }

    hide({ preserveState = false } = {}) {
      const wasOpen = this.hasAttribute('open');

      this.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove(CLASSES.scrollLocked);
      removeTrapFocus(this.focusElement);

      if (wasOpen && !preserveState) this.dispatchEvent(new CustomEvent(EVENTS.closed));
    }

    show(focusElement) {
      this.dispatchEvent(new CustomEvent(EVENTS.opening));
      this.focusElement = focusElement;
      this.setAttribute('open', '');

      if (!this.querySelector(SELECTORS.overlay)) document.body.addEventListener('click', this.onBodyClick);

      document.body.classList.add(CLASSES.scrollLocked);
      trapFocus(this);
    }
  }

  customElements.define(ELEMENT_NAME, PickupAvailabilityDrawer);
})();
